import { AUTH_CONFIG } from '../config/auth'

function getApiUrl(path) {
  return `${AUTH_CONFIG.apiBaseUrl.replace(/\/$/, '')}${path}`
}

export function getOidcLoginUrl(redirectUri) {
  const loginUrl = new URL(getApiUrl(AUTH_CONFIG.oidcLoginPath), window.location.origin)
  if (redirectUri) loginUrl.searchParams.set('redirectUri', redirectUri)
  return loginUrl.toString()
}

export async function getAppConfig() {
  const response = await fetch(getApiUrl(AUTH_CONFIG.appConfigPath))
  if (!response.ok) throw new Error(`应用配置请求失败（${response.status}）`)
  return response.json()
}

export async function oidcTicketLogin(ticket) {
  const response = await fetch(getApiUrl(AUTH_CONFIG.oidcTicketLoginPath), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ Ticket: ticket })
  })

  if (!response.ok) {
    throw new Error(`登录接口请求失败（${response.status}）`)
  }

  return response.json()
}

export async function getCurrentUser(accessToken) {
  const response = await fetch(getApiUrl(AUTH_CONFIG.currentUserPath), {
    headers: {
      'ACCESS-TOKEN': accessToken
    }
  })

  if (!response.ok) {
    const error = new Error(`用户信息请求失败（${response.status}）`)
    error.status = response.status
    throw error
  }

  return response.json()
}
